/* 之前写直接转跳到结账页的支付按钮的时候，写的全局脚本。该文件基本废弃了，不再使用 */
function globalIsElementInViewport(el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < window.pageYOffset + window.innerHeight &&
    left < window.pageXOffset + window.innerWidth &&
    top + height > window.pageYOffset &&
    left + width > window.pageXOffset
  );
}

function globalOnVisibilityChange(el, callback) { //使用globalOnVisibilityChange处，仅仅在显隐变化时执行回调
  let oldVisible;
  return function () {
    const visible = globalIsElementInViewport(el);
    if (visible !== oldVisible) {
      oldVisible = visible;
      if (typeof callback === 'function') {
        callback(visible);
      }
    }
  };
}

function globalVisibilityValue(el, callback) { //使用globalVisibilityValue处，总是执行回调
  return function () {
    const visible = globalIsElementInViewport(el);
    callback(visible);
  };
}

function globalIsMobileByWidth() {
  // 判断屏幕宽度是否小于等于 768 像素
  return window.innerWidth <= 768;
}
